import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function MockupShowcase() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-gradient-to-b from-amber-50 to-white py-16 md:py-20" data-id="element-95">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-97">
          <img src="https://cdn.magicpatterns.com/uploads/mkx1JNBoiNtD9mQ9Qe5XtW/mockup.png" alt="Vista previa de las actividades imprimibles de Aprendo Jugando: sopas de letras, laberintos, unir puntos y los bonos incluidos" className="rounded-3xl shadow-2xl mx-auto w-full max-w-lg" data-id="element-98" />
        </motion.div>
      </div>
    </section>;
}